(() => {
  window.theme = window.theme || {};
  if (window.theme.pageTOCInitialized) return;
  window.theme.pageTOCInitialized = true;

  const TOC_SELECTOR = '[data-page-toc-root]';
  const LIST_SELECTOR = '[data-page-toc-list]';
  const MAIN_SELECTOR = '#MainContent, .main-content, main[role="main"], main';

  const slugify = (value) =>
    value
      .toString()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '') || 'section';

  const getMainContent = () =>
    document.querySelector(MAIN_SELECTOR) || document.body;

  const ensureHeadingId = (heading, usedIds, index) => {
    if (heading.id) {
      usedIds.add(heading.id);
      heading.classList.add('page-toc-anchor');
      return heading.id;
    }

    const baseId = slugify(heading.textContent || `section-${index + 1}`);
    let nextId = baseId;
    let duplicateIndex = 2;

    while (usedIds.has(nextId)) {
      nextId = `${baseId}-${duplicateIndex}`;
      duplicateIndex += 1;
    }

    heading.id = nextId;
    heading.classList.add('page-toc-anchor');
    usedIds.add(nextId);
    return nextId;
  };

  const collectHeadings = (tocRoot) => {
    const mainContent = getMainContent();
    const currentSection = tocRoot.closest('.shopify-section');
    const selector = tocRoot.dataset.pageTocLevels || 'h2,h3';
    const excludeCurrentSection =
      tocRoot.dataset.pageTocExcludeCurrentSection === 'true';

    return Array.from(mainContent.querySelectorAll(selector)).filter((heading) => {
      if (!heading.textContent.trim()) return false;
      if (heading.closest(TOC_SELECTOR)) return false;
      if (heading.closest('header, footer')) return false;

      const section = heading.closest('.shopify-section');
      if (excludeCurrentSection && currentSection && section === currentSection) {
        return false;
      }

      return true;
    });
  };

  const buildToc = (tocRoot) => {
    const list = tocRoot.querySelector(LIST_SELECTOR);
    if (!list) return;

    const headings = collectHeadings(tocRoot);
    const usedIds = new Set(
      Array.from(getMainContent().querySelectorAll('[id]'), ({ id }) => id).filter(Boolean),
    );

    list.innerHTML = '';

    if (!headings.length) {
      tocRoot.hidden = true;
      return;
    }

    headings.forEach((heading, index) => {
      const item = document.createElement('li');
      const link = document.createElement('a');
      const level = Number.parseInt(heading.tagName.replace('H', ''), 10) || 2;
      const id = ensureHeadingId(heading, usedIds, index);

      item.className = 'page-toc__item';
      item.style.setProperty('--toc-level', level);

      link.className = 'page-toc__link reversed-link';
      link.href = `#${id}`;
      link.textContent = heading.textContent.trim();

      item.appendChild(link);
      list.appendChild(item);
    });

    tocRoot.hidden = false;
  };

  const init = (root = document) => {
    root.querySelectorAll(TOC_SELECTOR).forEach(buildToc);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', () => {
    init();
  });
})();
